import { Skeleton, Box, Card, CardContent, Container } from "@mui/material";

function LabReportsImagesLoading() {
    return (
        <Container maxWidth="md" sx={{ py: 2 }}>
            <Card
                elevation={3}
                sx={{
                    width: { xs: '100%', md: '100%' },
                    mx: 'auto',
                    overflow: 'visible'
                }}
            >
                <CardContent>
                    {/* Main image skeleton */}
                    <Box sx={{ position: 'relative', mb: 2 }}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={300}
                            animation="wave"
                            sx={{ borderRadius: 1 }}
                        />
                    </Box>

                    {/* Thumbnail skeletons */}
                    <Box
                        sx={{
                            display: 'flex',
                            overflowX: 'auto',
                            gap: 0.8,
                            pb: 0.5,
                        }}
                    >
                        {Array(6).fill(0).map((_, index) => (
                            <Skeleton
                                key={index}
                                variant="rectangular"
                                width={70}
                                height={60}
                                animation="wave"
                                sx={{ flexShrink: 0 }}
                            />
                        ))}
                    </Box>
                </CardContent>
            </Card>
        </Container>
    );
}

export default LabReportsImagesLoading;